import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from './cn';
import type { ChannelPerson } from '@/lib/channelPerson';
import { PersonPeek } from './PersonSummary';

/** A name in prose keeps the surrounding font, baseline and punctuation. Lists use EntityChip. */
interface EntityTextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  person?: ChannelPerson;
  prefix?: '#' | '';
  variant?: 'mention' | 'author';
}
export const EntityText = forwardRef<HTMLButtonElement, EntityTextProps>(
  ({ name, person, prefix = '', variant = 'mention', className, ...props }, ref) => {
    const link = (
      <button
        {...props}
        ref={ref}
        type="button"
        data-slot="entity-text"
        className={cn(
          'inline cursor-pointer rounded-xs p-0 align-baseline underline decoration-dotted underline-offset-4 transition-colors duration-fast focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
          variant === 'author'
            ? 'font-semibold text-fg decoration-line-strong hover:text-brand-fg hover:decoration-brand-fg'
            : 'font-medium text-brand-fg decoration-brand-fg/40 hover:decoration-brand-fg',
          className,
        )}
      >
        {prefix}
        {name}
      </button>
    );
    return person ? <PersonPeek person={person}>{link}</PersonPeek> : link;
  },
);
EntityText.displayName = 'EntityText';
